
if (!window.SwymCallbacks) window.SwymCallbacks = [];

function swymCallbackFn(swat) {
  // your API calls go here
  document.addEventListener("swym:collections-loaded", function () {
    swat.initializeActionButtons("#AjaxinateContainer");
  })
}

window.SwymCallbacks.push(swymCallbackFn);

window.SwymCallbacks.push(function () {

  window.loadWishlistBubble(0);

  $('.swym-add-to-wishlist-view-product').on('click', function (e) {
    e.preventDefault();
    if (SwymPageData) {
      SwymPageData.et = 4;  // et 4 stands for wishlist event type
      _swat.addToWishList(SwymPageData, function (e) {
        $('#add-to-wishlist').addClass('added');
        window.loadWishlistBubble(0);
      });
    }
  });

  window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.addedToWishlist, function (e) {
    window.loadWishlistBubble(1);
  });

  window._swat.evtLayer.addEventListener(SwymTracker.JSEvents.removedFromWishlist, function (e) {
    window.loadWishlistBubble(0);
  });
});

window.loadWishlistBubble = function (prevProduct) {
  _swat.fetchWrtEventTypeET(function (products) {
    $('.wishlist__bubble').html(products.length + prevProduct);
    if ((products.length + prevProduct) > 0) {
      $('.wishlist__bubble').addClass('wishlist__bubble--visible');
    } else {
      $('.wishlist__bubble').removeClass('wishlist__bubble--visible');
    }

  }, _swat.EventTypes.addToWishlist);
}
